import React from 'react';
import { PaywallModal } from '../auth/PaywallModal';
import { HeartRateMonitorSetupStudio } from '../HomeWorkouts/components/HeartRateMonitorSetupStudio';
import { LeaderboardModal } from '../Leaderboards/LeaderboardModal';
import { MealModal } from '../Nutrition/components/MealModal';
import { NutritionDietitianModal } from '../Nutrition/components/NutritionDietitianModal';
import NutritionStepsModal from '../Nutrition/NutritionStepsModal';
import { BookingWizard } from '../Planner/components/BookingWizard';
import { BlogPostModal } from '../ui';
import { BodyScaleAndWeightTargetModalContainer } from '../ui/components/BodyScaleAndWeightTargetModalContainer';

// Modals included here will only be available in the post auth app state.
// If your modal does not need a userProfile consider including it in AppRootModalContainer
export const AllModalsContainer = ({
  t,
  userProfile,
  userProfileService,
  waitingListServiceClient,
  workoutSessionService,
}) => {
  return (
    <>
      <BookingWizard
        userProfile={userProfile}
        userProfileService={userProfileService}
        waitingListServiceClient={waitingListServiceClient}
        workoutSessionService={workoutSessionService}
      />
      <MealModal />
      <NutritionDietitianModal />
      <NutritionStepsModal />
      <BlogPostModal />
      <LeaderboardModal />
      <BodyScaleAndWeightTargetModalContainer/>
      <PaywallModal userProfile={userProfile} userProfileService={userProfileService} />
      <HeartRateMonitorSetupStudio />
    </>
  );
};
